export default () => {
    const animationContainer = document.getElementById("approach-page-animation");
    import(/*webpackChunkName: 'error page animation'*/ "../classes/approachPageAnimationClass")
        .then(({ default: approachAnimation }) => {
        new approachAnimation(animationContainer);
    })
        .catch(() => "An error has occurred with Approach Page Animation");
};
